<template>
    <div class="page-wrapper">
        <TopBarGray
            :title="pageTitle"
            @clickBack="clickBack()"
            v-if="type != 'review' && type != 'getfriend' && type != 'survey' && type != 'surveydraw'" />
         <TopBarGray
            :title="pageTitle"
            customClass="bg-mission"
            @clickBack="clickBack()"
            v-if="type == 'getfriend'" />
        <TopBarWhiteCurve
            :title="pageTitle"
            @clickBack="clickBack()"
            v-if="type == 'review' || type == 'survey' || type == 'surveydraw'" />
        <div class="page-bg dark-bg" v-if="type == 'review' || type == 'survey' || type == 'surveydraw'"></div>
        <div class="page-content"
            :class="{'page-mission-detail' : type != 'review' && type != 'survey' && type != 'surveydraw'}"
            v-if="isLoaded">
            <Coupon4
                :lbl="lbl.mission.detail.coupon4"
                :modalController="modalController"
                :badgeDetail="badgeDetail"
                :isLoading="isLoading"
                @toggleLoading="toggleLoading($event)"
                v-if="type == 'coupon4' && isListLoading" />
            <Coupon6
                :lbl="lbl.mission.detail.coupon6"
                :modalController="modalController"
                :badgeDetail="badgeDetail"
                :isLoading="isLoading"
                @toggleLoading="toggleLoading($event)"
                v-if="type == 'coupon6' && isListLoading" />
            <Checkin ref="checkin" 
                :lbl="lbl.mission.detail.checkin"
                :modalController="modalController"
                :badgeDetailObj="badgeDetail"
                :badgeDayDetailObj="badgeDayDetail"
                :isLoading="isLoading"
                @toggleLoading="toggleLoading($event)"
                @showSuccessCheckin1Day="showSuccessCheckin1Day($event)"
                @showSuccessCheckin7day="showSuccessCheckin7day($event)"
                v-if="type == 'checkin' && isListLoading" />
            <ProductReview
                :lbl="lbl.mission.detail.review"
                :modalController="modalController"
                v-if="type == 'review' && isListLoading"/>
            <UpdateProfile
                v-if="type == 'update-profile' && isListLoading" />
            <GetFriend
                :lbl="lbl.mission.detail.get_friend"
                :modalController="modalController"
                :badgeDetail="badgeDetail"
                :isLoading="isLoading"
                :lineImage="lineImage"
                v-if="type == 'getfriend' && isListLoading" />
            <SurveyList
                :lbl="lbl.mission.detail.survey"
                :modalController="modalController"
                type="survey"
                v-if="type == 'survey' && isListLoading"/>
            <SurveyList
                :lbl="lbl.mission.detail.survey"
                :modalController="modalController"
                :surveyDraw="true" 
                type="surveydraw"
                v-if="type == 'surveydraw' && isListLoading"/>
                
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import TopBarGray from '@/components/Layout/TopBarPage/TopBarGray.vue';
import TopBarWhiteCurve from '@/components/Layout/TopBarPage/TopBarWhiteCurve.vue';
import Coupon4 from '../component/Coupon4.vue';
import Coupon6 from '../component/Coupon6.vue';
import Checkin from '../component/CheckIn.vue';
import ProductReview from '../component/ProductReview.vue';
import UpdateProfile from '../component/UpdateProfile.vue';
import GetFriend from '../component/GetFriend.vue';
import SurveyList from '../component/SurveyList.vue';
//core
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
 
export default {
    name: 'MissinDetail',
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        TopBarGray,
        TopBarWhiteCurve,
        Coupon4,
        Coupon6,
        Checkin,
        ProductReview,
        UpdateProfile,
        GetFriend,
        SurveyList,
    },
    data: function () {
        return {
            type: 'coupon4', //coupon4
            isLoaded: false,
            isLoading: false,
            isListLoading: false,

            lineImage: '',
            pageTitle: '',
            missionTitle: '',
            missionDesciption: '',
            badgeList: null,
            badgeDetail: null,
            badgeDayDetail: null,
            isRefreshBadge: false,
        };
    },
    created: function () {
        this.type = this.$route.params.type ? this.$route.params.type : 'coupon4';
        //console.log(this.type)
        //this.initialTitle();
        this.initailBadge(); 
        this.initialOtherModal();
    },
    methods: { 
        initailBadge: function(isReload){
            var token = this.getToken();
            BzbsProfile.getUserBadges(token).subscribe((res) => {
                //console.log(res);
                this.badgeList = res;
                this.getBadgeDetail(isReload);

            }, (err) => {
                this.errorApi(err);
            });
        },
        getBadgeDetail: function(isReload){
            var info = null;

            this.isListLoading = true;
            switch (this.type){
                case 'coupon4':
                    // this.badgeDetail = this.badgeList.filter(k => k.PartitionKey == 'BiodermaCoupon4_23213185')[0];
                    this.badgeDetail = this.badgeList.filter(k => k.PartitionKey.indexOf("BiodermaCoupon4") >= 0)[0];
                    if(this.badgeDetail.CustomInfo){
                        info = JSON.parse(this.badgeDetail.CustomInfo);
                        this.pageTitle = info.d_title;
                    }
                    break;
                case 'coupon6':
                    // this.badgeDetail = this.badgeList.filter(k => k.PartitionKey == 'BiodermaCoupon6_23121751')[0];
                    // this.badgeDetail = this.badgeList.filter(k => (k.PartitionKey == 'BiodermaCoupon6_23121751' || k.PartitionKey == 'BiodermaCoupon6_Starbuck'))[0];
                    this.badgeDetail = this.badgeList.filter(k => k.PartitionKey.indexOf("BiodermaCoupon6") >= 0)[0];
                    if(this.badgeDetail.CustomInfo){
                        info = JSON.parse(this.badgeDetail.CustomInfo);
                        this.pageTitle = info.d_title;
                    }
                    break;
                case 'update-profile':
                    this.pageTitle = this.lbl.mission.detail.update_profile.title;
                    break;
                case 'getfriend':
                    this.badgeDetail = this.badgeList.filter(k => k.PartitionKey == 'BiodermaInvitor')[0];
                    this.pageTitle = this.lbl.mission.detail.get_friend.title;
                    break;
                case 'review':
                    this.pageTitle = this.lbl.mission.detail.review.title;
                    break;
                case 'survey':
                case 'surveydraw':
                    this.pageTitle = this.lbl.mission.detail.survey.title;
                    break;
                case 'checkin':
                    this.badgeDetail = this.badgeList.filter(k => k.PartitionKey.indexOf("Bioderma_CheckIn7day") >= 0)[0];
                    if(this.badgeDetail.CustomInfo){
                        info = JSON.parse(this.badgeDetail.CustomInfo);
                        this.pageTitle = info.d_title;
                    } 
                    this.badgeDayDetail = this.badgeList.filter(k => k.PartitionKey.indexOf("Bioderma_CheckIn1day") >= 0)[0];
 
                    // หลังจาก ปิด popup ให้ update ด้วย
                    if (isReload) {   
                        try{ 
                            const element = this.$refs.checkin;  
                            //this.badgeDetail.Missions[0].Current = 17;
                            element.initialMission(this.badgeDetail, this.badgeDayDetail);
                        }catch(e){
                            console.log(e);
                        }
                    } 
                    //checkin
                    //this.showSuccessCheckin1Day();
                    break;
            }
        },
        //event
        showSuccessCheckin1Day: function () { 
            this.modalController.missionSuccessCheckinModal  
                .setTag('mission-success-checkin')
                .setIsSuccessAll(false)
                .show(); 
            this.modalController.missionSuccessCheckinModal.onClickPage(() => {
              
            });
            this.modalController.missionSuccessCheckinModal.onHidden((data) => {
                //reload mission 
                if (!this.isRefreshBadge) {
                    this.isRefreshBadge = true;
                    console.log('reload mission', data);
                    this.initailBadge(true);  
                }
            });
            
        },
        showSuccessCheckin7day: function (points) {  
            this.modalController.missionSuccessCheckinModal 
                .setPoint(points)
                .setTag('mission-success-checkin')
                .setIsSuccessAll(true)
                .show(); 
            this.modalController.missionSuccessCheckinModal.onClickPage(() => {
                this.$router.replace('/mission');
            }); 
            this.modalController.missionSuccessCheckinModal.onHidden((data) => {
                //reload mission 
                if (!this.isRefreshBadge) {
                    this.isRefreshBadge = true;
                    console.log('reload mission', data);
                    this.initailBadge(true);  
                }
            });
        },
        clickBack: function () {
            if(this.type == 'update-profile'){
                var lblPage = this.lbl.mission.detail.update_profile.modal_back;
                this.confirmModal
                    .clearText()
                    .setTitle(lblPage.title)
                    .setMsg(lblPage.message)
                    .setBtnOk(lblPage.btn_confirm)
                    .setBtnCancel(lblPage.btn_back)
                    .setTag('mission-back')
                    .show()

                this.confirmModal.onClickOk((data) =>{
                    if(data.tag == 'mission-back'){
                        this.$router.push('/mission');
                    }
                });

            }else{
                //this.$router.back();
                this.$router.push('/mission');
            }

            console.log('data');
        },
        //mixin
        accountInitiated: function () {
            this.isLoaded = true;
            this.lineImage = this.getPictureLine();
        },
        //utility
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '../style/MissionDetail.scss';
</style>
